/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class DmsApiConfiguration {
  rootUrl: string = '';
}

/**
 * Parameters for `DmsApiModule.forRoot()`
 */
export interface DmsApiConfigurationParams {
  rootUrl?: string;
}
